// Index route for /admin — defaults to the Beats surface, since
// publishing is the more frequent operator action than reviewing
// fallback letters.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/beats' });
  },
});
